import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {}

interface OwnProps extends WidgetProps {}

export interface FooterStripeStyles {
    wrapperStyles?: InjectableCss;
}

export const footerStripeStyles: FooterStripeStyles = {
    wrapperStyles: {
        css: css`
            background: linear-gradient(268deg, #44a8f7 0%, #0b70b7 100%);
            width: 100%;
            align-items: center;
            display: flex;
            div[class^="BlockSpacer"]{
                margin-top: 0;
                margin-bottom: 0;
                padding-right: 30px;
                padding-left: 30px;
            
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 10px;
                        padding-left: 10px;
                        padding-top: 10px;
                    `,
                    css`
                        padding-right: 10px;
                        padding-left: 10px;
                        padding-top: 10px;
                    `,
                ],
                "max",
            )}
        }
        `,
    },
};

type Props = WidgetProps;

const FooterStripe: React.FC<Props> = ({ fields, id }) => {
    const styles = footerStripeStyles;

    return (
        <>
        <StyledWrapper {...styles.wrapperStyles}>
            <Zone zoneName="ftr" contentId={id} />
        </StyledWrapper>
        </>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const footerStripe: WidgetModule = {
    component: FooterStripe,
    definition: {
        group: "Footer",
        fieldDefinitions: [],
    },
};

export default footerStripe;
